import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { addressFromForm, addressToForm, phoneFromForm, phoneToForm } from '~/utils/helper/setupForm';
import { FormValues, ICollectionAdapter, IHomeAddress, IPhone } from '~/utils/interface/setup';

export interface IPersonRow {
  id: string;
  firstName: string;
  lastName: string;
  phone?: IPhone | null;
  homeAddress?: IHomeAddress | null;
  relationship?: string | null;
  type?: string | null;
}

// Emergency contacts and doctor contacts share one shape; only the extra field
// differs (`relationship` vs `type`).
export const createPersonAdapter = (url: string, extraField: 'relationship' | 'type'): ICollectionAdapter<IPersonRow> => {
  const toBody = (form: FormValues) => ({
    firstName: String(form.firstName ?? '').trim(),
    lastName: String(form.lastName ?? '').trim(),
    [extraField]: String(form[extraField] ?? '').trim(),
    phone: phoneFromForm(form),
    homeAddress: addressFromForm(form),
  });

  return {
    list: async ({ page, limit, textSearch }) => {
      const resp = await axiosClient.get<IBaseResponse<IListDataResponse<IPersonRow[]>>>(url, {
        params: { page, limit, textSearch: textSearch || undefined },
      });
      return { rows: resp.data.data.responses, totalItems: resp.data.data.pagination.totalItems };
    },
    getId: (row) => String(row.id),
    rowToForm: (row) => ({
      firstName: row.firstName ?? '',
      lastName: row.lastName ?? '',
      [extraField]: row[extraField] ?? '',
      ...phoneToForm(row.phone),
      ...addressToForm(row.homeAddress),
    }),
    create: (form) => axiosClient.post(url, toBody(form)),
    update: (id, form) => axiosClient.put(`${url}/${id}`, toBody(form)),
    remove: (id) => axiosClient.delete(`${url}/${id}`),
  };
};
